import React, {Component} from 'react';
import 'react-table/react-table.css';
import edit from '../resources/images/estrategas/tools/edit.svg';
import labels from '../resources/images/estrategas/tools/Gauge Chart.svg';
import {AUDIT_REPORT, COMPLIANCE_AUDITS, EDIT_COMPLIANCE_AUDITS, SAVE_AUDIT_REPORT} from '../utils/constants';
import * as Request from '../service/data-info-chart/requestsUtil';
import {Button, Input, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import {RadialBar, RadialBarChart, ResponsiveContainer} from 'recharts';
import View from '../components/buttons/view';
import Save from '../components/buttons/save';


class auditCompliance extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.editActions = this.editActions.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      data: {percent: null},
      modal: false,
      size: null,
      key: null,
      modal2: false,
      percent: null,
      goalPercent: null,
      percentPrevious: null,
      goalPercentPrevious: null,
      percentFetch: null,
      selectedFile: null,
      text: ''
    };
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
    if (this.state.percent === '' || this.state.percent < 0 || this.state.percent > 100) {
      this.setState({percent: this.state.percentPrevious}, function stateUpdateComplete() {
        this.setState({key: Math.random()});
      }.bind(this));
    }
    if (this.state.goalPercent === '' || this.state.goalPercent < 0 || this.state.goalPercent > 100) {
      this.setState({goalPercent: this.state.goalPercentPrevious}, function stateUpdateComplete() {
        this.setState({key: Math.random()});
      }.bind(this));
    }
  }

  componentDidMount() {
    this._Fetch();
  }

  _Fetch() {
    Request.getFetch(COMPLIANCE_AUDITS + this.props.date)
      .then((json) => {
        this.setState({
          percent: json.percent,
          goalPercent: json.goalPorcent,
          percentPrevious: json.percent,
          goalPercentPrevious: json.goalPorcent,
          text: json.note,
          loaded: true,
        });
      });
  }

  editActions() {

    let percent = (this.state.percent === null || this.state.percent === '' ||
      this.state.percent < 0 || this.state.percent > 100) ?
      this.state.percentPrevious: this.state.percent;
    let goalPercent = (this.state.goalPercent === null || this.state.goalPercent === '' ||
      this.state.goalPercent < 0 || this.state.goalPercent > 100) ?
      this.state.goalPercentPrevious: this.state.goalPercent;

    let params = {
      'percent': percent,
      'goalPorcent': goalPercent,
      'date': this.props.date,
      'note': this.state.text
    };
    Request.postFetch(EDIT_COMPLIANCE_AUDITS, params)
      .then(() => {
        this._Fetch();
      });
    this.toggle();
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({[name]: value});
  }

  render() {

    const data = [
      {
        name: 'base',
        uv: 100,
        pv: 0,
        fill: '#fff'
      },
      {
        name: 'audit-compliance',
        uv: this.state.percent,
        pv: 0,
        fill: '#ff0000'
      }
    ];

    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';

    return (<div className='container-fluid'>
        <div className='row'>
          <div className='col-12'>
            <div className='container-fluid quality-title-1'>
              Cumplimiento de auditorías internas
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className={classUser}>
              <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
            </div>
            <Modal isOpen={this.state.modal} toggle={this.toggle}>
              <ModalHeader className='header-modal'
                           toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
              <ModalBody>
                <div className='d-flex justify-content-between m-3'>
                  <p className='mb-0 mr-2'>Porcentaje de cumplimiento:</p>
                  <Input placeholder="% numero" type="text" name="percent" id="percent"
                         value={this.state.percent} onChange={this.handleChange}
                         style={{width: '50%'}}/>
                </div>
                <div className='d-flex justify-content-between  m-3'>
                  <p className='mb-0 mr-2'>Porcentaje de meta por alcanzar:</p>
                  <Input placeholder="% numero" type="text" name="goalPercent" id="goalPercent"
                         value={this.state.goalPercent} onChange={this.handleChange}
                         style={{width: '50%'}}/>
                </div>
                <div className='m-3'>
                  <p className='mb-0 mr-2'>Agregue una nota:</p>
                <Input type='textarea' name='text' id='text'
                       value={this.state.text} onChange={this.handleChange}
                       style={{height:'100px'}} maxLength={500}/>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.editActions}>Aceptar</Button>{' '}
                <Button color="danger" onClick={this.toggle}>Cancelar</Button>
              </ModalFooter>
            </Modal>
            <div className='container p-0'>
              <div className='m-5'>
                <img className='img-odometer' src={labels}/>
                <div className='odometer-percent'>
                  <p>{this.state.percent}%</p>
                  <p className='odometer-legend'>Porcentaje de meta por
                    alcanzar {this.state.goalPercent}%</p>
                </div>
                <div className='odometer-graph' style={{
                  position: 'absolute',
                  top: '0vh',
                  left: '0%',
                  width: '100%',
                  height: '80vh',
                }}>
                  <ResponsiveContainer>
                    <RadialBarChart key={this.state.key}
                                    width={850}
                                    height={850}
                                    innerRadius="50%"
                                    outerRadius="100%"
                                    data={data} startAngle={180} endAngle={0}>
                      <RadialBar minAngle={15} background clockWise={true} dataKey='uv'/>
                    </RadialBarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <Save url={SAVE_AUDIT_REPORT} authorization={this.props.authorization}
                  date={this.props.date}/>
            <div className='container p-3'>
              <div className='mt-0 d-flex justify-content-center'>
                <div className='d-flex justify-content-center quality-title-3'
                     style={{marginTop: '2vh'}}>
                  Informe de auditoría
                </div>
                <div className='d-flex text-right ml-3'>
                  <View url={AUDIT_REPORT + this.props.date} date={this.props.date}/>
                </div>
              </div>
              <Input className='mt-3' readOnly type='textarea' name='text' id='text' value={this.state.text} style={{height:'200px'}}/>
            </div>
          </div>
        </div>
      </div>
    );

  }
}

export default auditCompliance;



// WEBPACK FOOTER //
// ./src/charts/auditCompliance.js